import React from 'react';
import {useSelector} from "react-redux";
import {bbFindEntityWithinPortfolioOrSelf} from "../../util/bbHelpers";
import {HashLink as Link} from "react-router-hash-link";
import {Button} from "@material-ui/core";

export const BizInitial_Social_ProLite = {
    url: `/board/BreachRisk/Business/Report/Social`,
    type: `tutorial`,
    user: {
        first_login: true,
    },
    entity: {
        verified_ownership: true,
        hasScores: null,
        // subscription: "Business",
        subLevel: ["lite", "pro"],
    },
    openingModal: {
        icon: null,
        heading: "Social Testing Beyond The Usual",
        description: <div className={"text-center"}>
            <p>
                <small>
                    <i>Social Testing requires a Premium subscription, but all subscriptions can see what email addresses we were able to collect from your company.</i>
                </small>
            </p>
            <p>
                Social Testing capabilities find identities and send carefully crafted attacks. In addition to seeing if your team <i>opens</i> these attacks, we report back on whether we were able to execute an attack.
            </p>
            <p>
                You can upgrade your service on the <Link to={`/board/settings/subscription#manageSubscription`} className={"text-white"}><u> Manage Subscription </u></Link> page.
            </p>
        </div>
    },
    tourSteps: {
        1: {
            step: 1,
            title: "Identities Trends",
            placement: "left",
            content: "Track the visibility of your company's social landscape over time.",
            scrollToElement: "#tourSocialStepOne",
            anchorEl: "#tourIdSocialHistory",
            element: null,
            last: false,
        },
        2: {
            step: 2,
            title: "Active Identities",
            content: "This table has all the identities we've discovered and any you've added for testing. ",
            placement: "top-center",
            scrollToElement: "#tourSocialIdentitiesTable",
            anchorEl: "#tourIdentitiesChart",
            element: null,
            last: false,
        },
        3:{
            step: 3,
            title: "Add New Identity",
            content: "If there are people we haven't discovered yet that you'd like to have included in a social campaign, you can add them here or on the Verifications Page.",
            placement: "top-center",
            scrollToElement: null,
            anchorEl: "#tourIdentitiesChart",
            element: document.getElementsByClassName("highlightAddITElementButton"),
            last: false,
        },
        4:{
            step: 4,
            title: "Remove Emails",
            placement: "left",
            content: "If an email address or identity should not be included in testing, you can set them out of scope here.",
            scrollToElement: null,
            anchorEl: "#tourSetScope",
            element: document.getElementsByClassName("tourSetScopeCol"),
            last: false,
        },
        5:{
            step: 5,
            title: "Get More When You Upgrade to Premium",
            content: <>
                <p>
                    Access to the full Social Engineering experience is only available with a Premium subscription.
                    Visit <Link to={`/board/settings/subscription#manageSubscription`} className={"text-white"}><u> Manage Subscription </u></Link>
                    to upgrade today or <Link href={"mailto:support@breachbits.com?subject=Question Regarding Social Engineering"} className={"text-white"}><u>email support@breachbits.com</u></Link>
                    to learn more about Premium features.
                </p>
            </>,
            scrollToElement: "#tourSocialResponseOverview",
            anchorEl: "#tourSocialResponseChart",
            element: null,
            last: true,
        },
    },
    style: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: "750px",
        // width: 400,
        // height: 250,
        background: 'white',
        borderRadius: "10px",
        // border: '1px solid #000',
        boxShadow: 24,
        p: 4,
        // zIndex: 1502,
    }
}